var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#00a300;}.b,.c{fill:none;}.c{stroke:#fff;stroke-linecap:round;stroke-width:1.6px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H40L0,40Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.001 4)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-964.881 -1091.881)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "c",
    y2: 6,
    transform: "translate(972.881 1096.881)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 6,
    transform: "translate(969.881 1099.881)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewNotification);
export default __webpack_public_path__ + "static/media/newNotification.2f7043a9887e4938c33d02b71c49ddbf.svg";
export { ForwardRef as ReactComponent };